var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatabase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.40625C4.34578 1.40625 1.875 2.84755 1.875 4.6875V10.3125C1.875 12.1525 4.34578 13.5938 7.5 13.5938C10.6542 13.5938 13.125 12.1525 13.125 10.3125V4.6875C13.125 2.84755 10.6542 1.40625 7.5 1.40625ZM12.1875 7.5C12.1875 8.06351 11.7261 8.6384 10.9216 9.07723C10.0153 9.57152 8.80019 9.84375 7.5 9.84375C6.19981 9.84375 4.98467 9.57152 4.07845 9.07723C3.27393 8.6384 2.8125 8.06351 2.8125 7.5V6.52479C3.81211 7.40161 5.52152 7.96875 7.5 7.96875C9.47848 7.96875 11.1879 7.40161 12.1875 6.52479V7.5ZM10.9216 11.8897C10.0153 12.384 8.80022 12.6562 7.5 12.6562C6.19978 12.6562 4.98467 12.384 4.07845 11.8897C3.27393 11.4509 2.8125 10.876 2.8125 10.3125V9.33729C3.81211 10.2141 5.52152 10.7812 7.5 10.7812C9.47848 10.7812 11.1879 10.2141 12.1875 9.33729V10.3125C12.1875 10.876 11.7261 11.4509 10.9216 11.8897Z",
    fill: "#7D7D7D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.58a9550e.svg";
export { ForwardRef as ReactComponent };